'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getRichText } from 'conversations-message-history/initial-message/operators/initialMessageGetters';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import ContentText from '../../primary-message/ContentText';
import PrimaryMessage from '../../primary-message/components/PrimaryMessage';
import PrimaryMessageContent from '../../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../../primary-message/components/PrimaryMessageContentSection';
import FeedbackSubmissionHeader from './FeedbackSubmissionHeader';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import AutomatedMessageAvatar from '../../avatar/AutomatedMessageAvatar';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "FeedbackSubmissionMessage__StyledDiv",
  componentId: "ae9rqj-0"
})(["display:flex;align-items:center;flex-direction:column;width:100%;padding:8px;"]);
const StyledContentColumn = styled.div.withConfig({
  displayName: "FeedbackSubmissionMessage__StyledContentColumn",
  componentId: "ae9rqj-1"
})(["display:flex;flex-direction:row;"]);
const FeedbackSubmissionMessage = ({
  message,
  positionDescriptors
}) => {
  const richText = getRichText(message);
  const submissionUrl = `${getFullUrl('app')}/feedback/${PortalIdParser.get()}/dashboard/manage/responses/${message.submissionId}`;
  const FeedbackContent = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FeedbackSubmissionHeader, {
      message: message
    }), /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
      children: [/*#__PURE__*/_jsx(ContentText, {
        contentText: richText
      }), /*#__PURE__*/_jsx(UILink, {
        href: submissionUrl,
        truncate: true,
        external: true,
        truncateStringProps: {
          maxWidth: 500
        },
        children: /*#__PURE__*/_jsx(Small, {
          children: submissionUrl
        })
      })]
    })]
  });
  FeedbackContent.displayName = 'FeedbackContent';
  return /*#__PURE__*/_jsx(PrimaryMessage, {
    positionDescriptors: positionDescriptors,
    use: AGENT,
    children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
      children: /*#__PURE__*/_jsxs(StyledContentColumn, {
        children: [/*#__PURE__*/_jsx(AutomatedMessageAvatar, {}), /*#__PURE__*/_jsx(StyledDiv, {
          children: /*#__PURE__*/_jsx(FeedbackContent, {})
        })]
      })
    })
  });
};
FeedbackSubmissionMessage.displayName = 'FeedbackSubmissionMessage';
FeedbackSubmissionMessage.propTypes = {
  message: RecordPropType('FeedbackSubmissionMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default FeedbackSubmissionMessage;